import React, { Component } from 'react';
import { Col } from "react-bootstrap";
import { HorizontalBar } from "react-chartjs-2";
import { addDataOnBar } from '../modules/helpers';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { PrinterStatusTypes } from "../containers/current_status_section";
import { MASTER_DASHBOARD_CHART_TYPE } from "../common/constants";

const printJobOutcomeSet = {
    labels: [],
    datasets: [
        {
            label: 'print',
            backgroundColor: 'rgba(75,192,192,1)',
            data: []
        }
    ]
};


export default class PrintDataPrintJobOutcome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            resinSelected: '',
            layerThicknessSelected: ''
        }
    }

    resolvePrintJobOutcomeSet = (selectedResin, layerThicknessSelected) => {
        const shouldResinFilter = Boolean(selectedResin);
        const shouldThicknessFilter = Boolean(layerThicknessSelected);
        const prints = this.props.prints.filter(item => {
            return (shouldResinFilter ? item.resinColor === selectedResin : true) && (shouldThicknessFilter ? item.layerThickness === layerThicknessSelected : true)
        });
        const endPrints = prints.filter(item => item.status === PrinterStatusTypes.END);
        const endPrintsCount = endPrints.length;
        const cancelPrintCount = prints.length - endPrintsCount;
        printJobOutcomeSet.labels = [PrinterStatusTypes.END, PrinterStatusTypes.CANCEL];
        printJobOutcomeSet.datasets[0].data = [endPrintsCount, cancelPrintCount];
    };

    handleResinChange = event => {
        const resinSelected = event.target.value;
        this.resolvePrintJobOutcomeSet(resinSelected, this.state.layerThicknessSelected);
        this.setState({ resinSelected });
    };

    handleThicknessChange = event => {
        const layerThicknessSelected = event.target.value;
        this.resolvePrintJobOutcomeSet(this.state.resinSelected, layerThicknessSelected);
        this.setState({ layerThicknessSelected });
    };

    render() {
        const prints = this.props.prints;
        let resinSelected = this.state.resinSelected;
        let layerThicknessSelected = this.state.layerThicknessSelected;
        if (this.prints !== prints) {
            const resins = new Set();
            const layerThicknesses = new Set();
            for (const item of prints) {
                resins.add(item.resinColor);
                layerThicknesses.add(item.layerThickness);
            }
            this.prints = prints;
            this.resins = [...resins];
            this.layerThicknesses = [...layerThicknesses];
            if (!this.resins.includes(resinSelected)) {
                resinSelected = '';
            }
            if (!this.layerThicknesses.includes(layerThicknessSelected)) {
                layerThicknessSelected = '';
            }
            this.resolvePrintJobOutcomeSet(resinSelected, layerThicknessSelected);
        }
        return (
            <Col lg={6} md={6} xs={12}>
                <form autoComplete="off">
                    <FormControl className='bar-select-form-control'>
                        <InputLabel htmlFor="resinSelected">Resin</InputLabel>
                        <Select
                            value={resinSelected}
                            onChange={this.handleResinChange}
                            inputProps={{
                                name: 'resinSelected',
                                id: 'resinSelected',
                            }}
                        >
                            <MenuItem value=''>All</MenuItem>
                            {
                                this.resins.map(item => <MenuItem key={'resin-' + item} value={item}>{item}</MenuItem>)
                            }
                        </Select>
                    </FormControl>
                    <FormControl className='bar-select-form-control'>
                        <InputLabel htmlFor="thicknessSelected">Thickness</InputLabel>
                        <Select
                            value={layerThicknessSelected}
                            onChange={this.handleThicknessChange}
                            inputProps={{
                                name: 'layerThicknessSelected',
                                id: 'thicknessSelected',
                            }}
                        >
                            <MenuItem value=''>All</MenuItem>
                            {
                                this.layerThicknesses.map(item => <MenuItem key={'thickness-' + item}
                                                                            value={item}>{item}</MenuItem>)
                            }
                        </Select>
                    </FormControl>
                </form>
                <HorizontalBar
                    data={printJobOutcomeSet}
                    getElementAtEvent={element => {
                        if (element.length === 0) {
                            return
                        }
                        const index = element[0]._index;
                        const label = element[0]._chart.data.labels[index];
                        const value = element[0]._chart.data.datasets[0].data[index];
                        this.props.handleChartsClick({
                            chartType: MASTER_DASHBOARD_CHART_TYPE.PRINT_OUTCOME,
                            label,
                            value,
                            resin: resinSelected,
                            thickness: layerThicknessSelected
                        })
                    }}
                    options={{
                        title: {
                            display: true,
                            text: 'Print Job Outcome',
                            fontSize: 20
                        },
                        scaleBeginAtZero: true,
                        hover: {
                            animationDuration: 0
                        },
                        animation: {
                            onComplete: (chart) => {
                                addDataOnBar(chart, 12, 6)
                            }
                        }
                    }}
                />
            </Col>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/print-data-print-job-outcome.js